// Detecta el "subdominio" del negocio a partir del hostname del navegador.
// Ej: https://clinica1.mascotas.vet -> "clinica1"
//
// Mientras uses una sola URL para todo (ej. app.mascotas.vet) en vez de un
// subdominio por negocio, VITE_TENANT_SUBDOMAIN fuerza siempre el mismo
// negocio, sin importar qué dirección visite el usuario. El día que actives
// subdominios por cliente (ej. miclinica.mascotas.vet para cada negocio),
// simplemente quita esa variable en Railway y el sistema volverá a detectar
// el negocio automáticamente según la URL.
export const BASE_DOMAIN = import.meta.env.VITE_APP_BASE_DOMAIN ?? "mascotas.vet";
const FORZADO = import.meta.env.VITE_TENANT_SUBDOMAIN as string | undefined;

export function getTenantSubdomain(): string {
  if (FORZADO) return FORZADO;

  const host = window.location.hostname;

  if (host === "localhost" || host === "127.0.0.1") {
    return localStorage.getItem("vetflow_dev_subdomain") ?? "demo";
  }

  if (host.endsWith(`.${BASE_DOMAIN}`)) {
    const parts = host.replace(`.${BASE_DOMAIN}`, "");
    return parts;
  }

  // Fallback: primer segmento del hostname
  return host.split(".")[0];
}

export function setDevSubdomain(subdomain: string) {
  localStorage.setItem("vetflow_dev_subdomain", subdomain);
}

// El dominio raíz (mascotas.vet o www.mascotas.vet, sin subdominio de
// negocio) sirve el portal de inicio público (Landing) en vez del login de
// un negocio — se detecta comparando el hostname exacto contra BASE_DOMAIN.
export function esDominioRaiz(): boolean {
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return false;
  return host === BASE_DOMAIN || host === `www.${BASE_DOMAIN}`;
}
